import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Option } from '../../../../../../../core/models/option.model';

@Injectable({
  providedIn: 'root',
})
export class AdvancedSearchService {
  speedRPMs$ = new BehaviorSubject<Option[]>([]);
  outputHPs$ = new BehaviorSubject<Option[]>([]);
  voltages$ = new BehaviorSubject<Option[]>([]);
  frameSizes$ = new BehaviorSubject<Option[]>([]);
  outputKWs$ = new BehaviorSubject<Option[]>([]);
  mountings$ = new BehaviorSubject<Option[]>([]);
  phases$ = new BehaviorSubject<Option[]>([]);
  enclosures$ = new BehaviorSubject<Option[]>([]);

  clearAdvancedSearch$ = new EventEmitter();

  isInList(value: string, options: Option[]) {
    return options.find(option => option.code === value);
  }

  clearAdvancedSearch() {
    this.clearAdvancedSearch$.emit();
  }
}
